function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var MobileShare = function MobileShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    fillRule: "evenodd",
    d: "M4.27 2.26a.253.253 0 0 0-.25.25v19c0 .136.114.25.25.25h12c.136 0 .25-.114.25-.25v-2.54a.75.75 0 0 1 1.5 0v2.54c0 .964-.786 1.75-1.75 1.75h-12c-.964 0-1.75-.786-1.75-1.75v-19c0-.964.786-1.75 1.75-1.75h12c.964 0 1.75.786 1.75 1.75v2.42a.75.75 0 0 1-1.5 0V2.51a.253.253 0 0 0-.25-.25zm4 2.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m3 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-.36-5.76a.75.75 0 0 1 .75-.75h10.09a.75.75 0 0 1 .53 1.28l-2.96 2.96a.75.75 0 1 1-1.06-1.06l1.68-1.68h-8.28a.75.75 0 0 1-.75-.75m4.231-5.93a.75.75 0 1 0-1.062-1.06l-2.95 2.96a.75.75 0 0 0 .53 1.28h10.09a.75.75 0 1 0 0-1.5h-8.283z",
    clipRule: "evenodd"
  }));
};
export default MobileShare;
MobileShare.displayName = 'MobileShare';